<template>
  <div class="content">
    <div style="display: flex; margin-bottom: 20px; justify-content: space-between">
      <div>
        <h1 class="jzlb">账号列表</h1>
      </div>
      <div>
        <a-button type="primary" @click="showModal">新增</a-button>
      </div>
    </div>
    <a-table :columns="columns" :data-source="data" :pagination="false"
      style="background-color: transparent !important; color: #fff">
      <template #headerCell="{ column }">
        <template v-if="column.key === 'name'">
          <span>
            {{ column.name }}
          </span>
        </template>
      </template>

      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'name'">
          {{ record.name }}
        </template>

        <template v-else-if="column.key === 'action'">
          <span>
            <a @click="showModal(record.id)">编辑</a>
          </span>
          <span>
            <a> 删除</a>
          </span>
        </template>
      </template>
    </a-table>
  </div>

  <a-modal v-model:visible="visible" width="600px" title="编辑用户" @ok="handleOk" cancelText="取消" okText="确定" :bodyStyle="{
    color: '#fff',
    background: '#0d2a4b',
    borderbottom: '1px #2b85e4 solid',
  }">
    <div style="width: 80%">
      <a-form :model="formState2" name="basic" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" autocomplete="off">
        <a-form-item label="账号">
          <a-input v-model:value="formState2.username" disabled />
        </a-form-item>

        <a-form-item label="密码">
          <a-input v-model:value="formState2.password" type="password" />
        </a-form-item>
        <a-form-item label="姓名">
          <a-input v-model:value="formState2.fullName" />
        </a-form-item>
        <!-- <a-form-item label="电话" name="phone" :rules="[{ required: true, message: '请输入电话!' }]"></a-form-item> -->
        <a-form-item label="电话">
          <a-input v-model:value="formState2.phone" />
        </a-form-item>
        <a-form-item label="性别">
          <a-radio-group v-model:value="formState2.gender">
            <a-radio :value="1"><span style="color: #fff">女</span></a-radio>
            <a-radio :value="2"><span style="color: #fff">男</span></a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
      <!-- <a-row>
        <a-col :span="4" style="text-align: right">权限：</a-col>
        <a-col :span="20">
          <div>
            <li>
              <div>
                <ul>
                  <li>
                    <a-checkbox v-model:checked="checked"
                      ><span style="font-size: 14px; color: #fff"
                        >站点总览</span
                      ></a-checkbox
                    >
                  </li>
                  <li style="padding-left: 25px">
                    <a-checkbox v-model:checked="checked"
                      ><span style="font-size: 14px; color: #fff"
                        >操作</span
                      ></a-checkbox
                    >
                  </li>
                  <li style="padding-left: 25px">
                    <a-checkbox v-model:checked="checked"
                      ><span style="font-size: 14px; color: #fff"
                        >站点详情</span
                      ></a-checkbox
                    >
                  </li>
                  <li style="padding-left: 50px">
                    <a-checkbox v-model:checked="checked"
                      ><span style="font-size: 14px; color: #fff"
                        >操作</span
                      ></a-checkbox
                    >
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>
                    <a-checkbox v-model:checked="checked"
                      ><span style="font-size: 14px; color: #fff"
                        >权限管理</span
                      ></a-checkbox
                    >
                  </li>
                  <li style="padding-left: 25px">
                    <a-checkbox v-model:checked="checked"
                      ><span style="font-size: 14px; color: #fff"
                        >操作</span
                      ></a-checkbox
                    >
                  </li>
                </ul>
              </div>
            </li>
          </div>
        </a-col>
      </a-row> -->
    </div>
  </a-modal>
</template>

<script>
import http from "@/api/http";
import { defineComponent, reactive, ref, onMounted } from "vue";
import { message } from 'ant-design-vue';
const columns = [
  {
    title: "账号",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "姓名",
    dataIndex: "fullName",
    key: "fullName",
  },
  {
    title: "注册时间",
    dataIndex: "createdAt",
    key: "createdAt",
  },
  {
    title: "操作",
    key: "action",
  },
];
let data = ref([]);

export default defineComponent({
  name: "JiZhan",
  components: {},
  props: {},
  setup() {
    let value = ref("2");
    const expand = ref(true);
    const formRef = ref();
    const formState = reactive({});
    const formState2 = ref({});
    const onFinish = (values) => {
      console.log("Received values of form: ", values);
      console.log("formState: ", formState);
    };

    const visible = ref(false);

    const showModal = (e) => {

      http.get("/user/" + e).then((res) => {
        console.log(res);
        formState2.value = res.data;
        visible.value = true;
      });

      console.log("123", formState2.value.gender);
      console.log("234", formState2.value.username);
    };

    const handleOk = () => {
      http.post("/user/" + formState2.value.id, formState2.value).then((res) => {
        message.success('修改成功', res);
      });
      visible.value = false;
    };



    const onFinish2 = (values) => {
      console.log("Success:", values);
    };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };

    const getData = () => {
      http.get("/user/list/1").then((res) => {
        data.value = res.data.records;
      });
    };
    onMounted(() => {
      //组件挂载时的生命周期执行的方法

      getData();
    });

    return {
      formRef,
      formState,
      expand,
      onFinish,
      value1: ref("请选择"),
      data,
      columns,
      visible,
      showModal,
      handleOk,
      formState2,
      onFinish2,
      onFinishFailed,
      value,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lange="less">
.content {
  padding: 0 40px;
  background: url("@/assets/bg22.png");
  background-size: 100% 100%;
}

.jzlb {
  background: url("@/assets/biaoti.png") no-repeat;

  margin-top: 12px;
  font-weight: bold;
  padding-left: 30px;
  font-size: 14px;
  color: #fff;
  width: 288px;
}

.ant-table {
  background-color: transparent !important;
}

.ant-input {
  background-color: #fff !important;
  color: #333 !important;
}

.ant-input-password {
  background-color: #fff !important;
  color: #333 !important;
}

.ant-form-item-label>label {
  color: #fff !important;
}

.ant-table-thead>tr>th {
  background-color: #333 !important;
}
</style>
